import AxiosService from './AxiosService'

class PasswordPolicyRestService {
  static get(): Promise<any> {
    return AxiosService.get('/passwordPolicy')
  }

  static update(passwordPolicy: any): Promise<any> {
    return AxiosService.put('/passwordPolicy', passwordPolicy)
  }

  static reset(): Promise<any> {
    return AxiosService.put('/passwordPolicy/reset')
  }
}

export default PasswordPolicyRestService
